var _path, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationHomeSection1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 551,
    height: 851,
    viewBox: "0 0 551 851",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191 -69.5C191 -120.034 231.966 -161 282.5 -161C333.034 -161 374 -120.034 374 -69.5V759.5C374 810.034 333.034 851 282.5 851C231.966 851 191 810.034 191 759.5V-69.5Z",
    fill: "#005B7F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 842.374,
    y: 380.874,
    width: 168.933,
    height: 842,
    rx: 84.4663,
    transform: "rotate(90.1275 842.374 380.874)",
    fill: "#E29578"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 915.307,
    y: 497.874,
    width: 138.928,
    height: 842,
    rx: 69.4639,
    transform: "rotate(90.1275 915.307 497.874)",
    fill: "#FFDDD2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1018.24,
    y: 431.874,
    width: 110.488,
    height: 842,
    rx: 55.2441,
    transform: "rotate(90.1275 1018.24 431.874)",
    fill: "#E8F8FE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1091.25,
    y: 302.874,
    width: 112.107,
    height: 842,
    rx: 56.0537,
    transform: "rotate(90.1275 1091.25 302.874)",
    fill: "#679ACB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationHomeSection1);
export default __webpack_public_path__ + "static/media/IllustrationHOME_Section1.a3e0ca95dfb6383ebdf6bd7f676e64ae.svg";
export { ForwardRef as ReactComponent };